module.exports = __webpack_public_path__ + "img/img32.970ec751.svg";